export default [
    {
        path: '/pages/shop/shopConfig',
        name: '/pages/shop/shopConfig',
        component: () => import('@/views/shop/shopConfig.vue')
    },
    {
        path: '/pages/shop/shopIntegral',
        name: '/pages/shop/shopIntegral',
        component: () => import('@/views/shop/shopIntegral.vue')
    },
    {
        path: '/pages/shop/shopSmsDetail',
        name: '/pages/shop/shopSmsDetail',
        component: () => import('@/views/shop/shopSmsDetail.vue')
    },
    {
        path: '/pages/shop/integralShopRule',
        name: '/pages/shop/integralShopRule',
        component: () => import('@/views/shop/integralShopRule.vue')
    },
    {
        path: '/pages/shop/printerMachine',
        name: '/pages/shop/printerMachine',
        component: () => import('@/views/shop/printerMachine.vue')
    },
    {
        path: '/pages/shop/printerMachineLog',
        name: '/pages/shop/printerMachineLog',
        component: () => import('@/views/shop/printerMachineLog.vue')
    },
    {
        path: '/pages/shop/shop',
        name: '/pages/shop/shop',
        component: () => import('@/views/shop/shop.vue')
    },
    {
        path: '/pages/shop/shopAudit',
        name: '/pages/shop/shopAudit',
        component: () => import('@/views/shop/shopAudit.vue')
    },
    {
        path: '/pages/shop/shopAuditDetail',
        name: '/pages/shop/shopAuditDetail',
        component: () => import('@/views/shop/shopAuditDetail.vue')
    },
    {
        path: '/pages/shop/aShopData',
        name: '/pages/shop/aShopData',
        component: () => import('@/views/shop/aShopData.vue')
    },
    {
        path: '/pages/shop/aShopDetail',
        name: '/pages/shop/aShopDetail',
        component: () => import('@/views/shop/aShopDetail.vue')
    },
    {
        path: '/pages/shop/aShopSms',
        name: '/pages/shop/aShopSms',
        component: () => import('@/views/shop/aShopSms.vue')
    },
    {
        path: '/pages/shop/aShopSmsDetail',
        name: '/pages/shop/aShopSmsDetail',
        component: () => import('@/views/shop/aShopSmsDetail.vue')
    },
    {
        path: '/pages/shop/cityArea',
        name: '/pages/shop/cityArea',
        component: () => import('@/views/shop/cityArea.vue')
    },
    {
        path: '/pages/shop/integralShopGift',
        name: '/pages/shop/integralShopGift',
        component: () => import('@/views/shop/integralShopGift.vue')
    },
    {
        path: '/pages/shop/aShop',
        name: '/pages/shop/aShop',
        component: () => import('@/views/shop/aShop.vue')
    },
    {
        path: '/views/shop/shopServiceRule',
        name: '/views/shop/shopServiceRule',
        component: () => import('@/views/shop/shopServiceRule.vue')
    }
] 